import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextValue from "./controls/TextValue";
import MeasureValue from "./controls/MeasureValue";
import LongTextValue from "./controls/LongTextValue";
import LabeledValue from "./controls/LabeledValue";
import BooleanValue from "./controls/BooleanValue";
import ObjectValue from "./controls/ObjectValue";
import { DestinoResiduoTratamiento } from "../utils/enums";

export function ResiduoTratamientoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((residuoTratamiento, index) => (
        <ListGroupObjectItem
          key={residuoTratamiento.orden}
          index={index}
          value={residuoTratamiento}
          indexLabel={t("residuoTratamiento.orden")}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("residuosTratamiento").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("residuoTratamiento.nombre")}
                    value={value?.nombre}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("residuoTratamiento.cantidad")}
                    value={value?.cantidad}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LongTextValue
                    label={t("residuoTratamiento.descripcion")}
                    value={value?.descripcion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("residuoTratamiento.destino")}
                    value={value?.destino}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("residuoTratamiento.conPeligrosidad")}
                    value={value?.conPeligrosidad}
                  />
                </Col>
              </Row>
              {!value?.conPeligrosidad &&
                value.destino?.codigo === DestinoResiduoTratamiento.EXTERNO && (
                  <>
                    <Row>
                      <Col>
                        <ObjectValue
                          label={t("residuoTratamiento.transportista")}
                          value={value?.transportista}
                        >
                          {({ value }) => (
                            <>
                              <Grid>
                                <Row>
                                  <Col>
                                    <TextValue
                                      label={t("personaJuridica.CUIT")}
                                      value={value?.CUIT}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <TextValue
                                      label={t("personaJuridica.razonSocial")}
                                      value={value?.razonSocial}
                                    />
                                  </Col>
                                </Row>
                              </Grid>
                            </>
                          )}
                        </ObjectValue>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <LabeledValue
                          label={t("residuoTratamiento.frecuenciaRetiros")}
                          value={value?.frecuenciaRetiros}
                          labelAttr="nombre"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <ObjectValue
                          label={t("residuoTratamiento.tratador")}
                          value={value?.tratador}
                        >
                          {({ value }) => (
                            <Grid>
                              <Row>
                                <Col>
                                  <TextValue
                                    label={t("personaJuridica.CUIT")}
                                    value={value?.CUIT}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <TextValue
                                    label={t("personaJuridica.razonSocial")}
                                    value={value?.razonSocial}
                                  />
                                </Col>
                              </Row>
                            </Grid>
                          )}
                        </ObjectValue>
                      </Col>
                    </Row>
                  </>
                )}
              {!value.conPeligrosidad &&
                value.destino?.codigo === DestinoResiduoTratamiento.INTERNO && (
                  <Row>
                    <Col>
                      <LongTextValue
                        label={t("residuoTratamiento.tratamiento")}
                        value={value?.tratamiento}
                      />
                    </Col>
                  </Row>
                )}
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
